import { cloneElement } from 'react';
import { twMerge } from 'tailwind-merge';
import type { FormFieldTypeId } from '@witmetrics/utils';
import { FIELDS } from './constants';
import { buildIconClasses, classes } from './utils';

export type FieldTypeIconProps = {
  className?: string;
  iconClassName?: string;
  fieldTypeId: FormFieldTypeId;
};

export default function FieldTypeIcon({
  className,
  iconClassName,
  fieldTypeId,
}: FieldTypeIconProps) {
  const Icon = FIELDS[fieldTypeId];
  return (
    <div className={buildIconClasses(fieldTypeId, className)}>
      {cloneElement(<Icon />, {
        className: twMerge(classes.icon, iconClassName),
      })}
    </div>
  );
}
